import React from "react";
import { useTranslation } from "react-i18next"
import { renderInputView } from "./helper";
import { INPUT_TYPES } from "../../../config";

const INPUT_STYLE = { width: 'calc(50% - 10px)' };

export default function Content({
  activeForm = {},
  data = {},
}) {
  const { t } = useTranslation();

  const renderInput = (input) => {
    if (input.type === INPUT_TYPES.INPUT_GROUP) {
      return (
        <React.Fragment key={input.key}>
          {(input.inputs || []).map(renderInput)}
        </React.Fragment>
      )
    }

    return (
      <div className="input" style={INPUT_STYLE}>
        <div className="label">
          {t(input.label)}
        </div>
        {renderInputView({ input, data, t })}
      </div>
    )
  }

  return (
    <div className="content">
      <div className="wrapper">
        {(activeForm?.inputGroups || []).map((gr) => (
          <div key={gr.key} className="group">
            {gr.title ? (
              <div className="title with-subtitle">
                <h1>{t(gr.title)}</h1>
                {gr.subTitle ? (
                  <p>{t(gr.subTitle)}</p>
                ) : null}
              </div>
            ) : null}
            {(gr.inputs || [])
              .filter((i) => {
                if (typeof i.showIf === 'function') {
                  return i.showIf(data);
                }

                return true;
              })
              .map(renderInput)}
          </div>
        ))}
      </div>
    </div>
  )
}
